import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import chesiLogo from '../../chesi-logo.png';
import api from '../../services/api';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';
import ShopHeaderSearch from './ShopHeaderSearch';
import './ShopLayout.css';

function ShopLayout({ children, breadcrumbs = [] }) {
  const { cartCount } = useCart();
  const { isAuthenticated, customer } = useAuth();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.getPublicShopCategories();
        if (!cancelled) setCategories(Array.isArray(res?.data) ? res.data : []);
      } catch {
        if (!cancelled) setCategories([]);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="shop-layout">
      <header className="shop-header">
        <div className="header-top">
          <div className="container">
            <div className="header-content">
              <Link to="/shop" className="logo">
                <img src={chesiLogo} alt="Chesi" className="logo-img" />
                <span className="logo-text">AIDC Products</span>
              </Link>
              <ShopHeaderSearch inputClassName="search-input" buttonClassName="search-btn" />
              <div className="header-links">
                {isAuthenticated ? (
                  <Link to="/account" className="header-link">{customer?.first_name?.toUpperCase() || 'MY ACCOUNT'}</Link>
                ) : (
                  <Link to="/login" className="header-link">LOGIN</Link>
                )}
                <Link to="/cart" className="header-link">CART ({cartCount})</Link>
                <a href="tel:+254711435629" className="header-link">Sales: +254 727 450523</a>
              </div>
            </div>
          </div>
        </div>
        <nav className="shop-nav">
          <div className="container">
            <ul className="nav-menu">
              <li><Link to="/shop">Shop Home</Link></li>
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link to={`/shop/category/${cat.slug}`}>{cat.name}</Link>
                </li>
              ))}
              <li><Link to="/shop/brands">Brands</Link></li>
              <li><Link to="/raise-ticket">Support</Link></li>
            </ul>
          </div>
        </nav>
      </header>

      {breadcrumbs.length > 0 && (
        <nav className="shop-breadcrumbs" aria-label="Breadcrumb">
          <div className="container">
            <ol>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/shop">Shop</Link></li>
              {breadcrumbs.map((crumb, i) => (
                <li key={crumb.label}>
                  {crumb.to && i < breadcrumbs.length - 1 ? (
                    <Link to={crumb.to}>{crumb.label}</Link>
                  ) : (
                    <span aria-current="page">{crumb.label}</span>
                  )}
                </li>
              ))}
            </ol>
          </div>
        </nav>
      )}

      <main className="shop-layout__main">{children}</main>

      <footer className="shop-footer">
        <div className="container">
          <div className="shop-footer__grid">
            <div>
              <h4>Shop</h4>
              <ul>
                <li><Link to="/shop">All Products</Link></li>
              <li><Link to="/shop/brands">Shop by Brand</Link></li>
              <li><Link to="/wishlist">Wishlist</Link></li>
            </ul>
          </div>
          <div>
            <h4>Policies</h4>
            <ul>
              <li><Link to="/shipping-policy">Shipping</Link></li>
              <li><Link to="/returns-policy">Returns</Link></li>
              <li><Link to="/privacy-policy">Privacy</Link></li>
              <li><Link to="/terms">Terms</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </div>
          <div>
            <h4>Support</h4>
            <ul>
              <li><Link to="/raise-ticket">Raise a Ticket</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><a href="tel:+254711435629">+254 727 450523</a></li>
            </ul>
          </div>
          <div>
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/">Chesi Home</Link></li>
              </ul>
            </div>
          </div>
          <p className="shop-footer__copy">© {new Date().getFullYear()} Chesi. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default ShopLayout;
